// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import liftNodes from 'utils/GraphQL/typedLiftNodes'
import NotificationBadge from 'components/SideBar/ui/NotificationBadge'
import type {
  InboxNotifications_viewer as Viewer,
} from './__generated__/InboxNotifications_viewer.graphql'

type Props = $ReadOnly<{
  viewer: Viewer,
}>

function InboxNotifications({viewer}: Props): Node {
  // We have to filter processed tensions from unprocessed tensions connection cuz tensions
  // may be processed in runtime
  const tensions = liftNodes(viewer.unprocessedTensions).filter(({processed}) => !processed)

  if (tensions.length === 0)
    return null

  return (
    <NotificationBadge count={tensions.length} />
  )
}

export default (createFragmentContainer(InboxNotifications, {
  viewer: graphql`
    fragment InboxNotifications_viewer on Person {
      unprocessedTensions(first: 100) @connection(key: "InboxNotifications_unprocessedTensions") {
        edges {
          node {
            processed
          }
        }
      }
    }
  `,
}): RelayFragmentContainer<typeof(InboxNotifications)>)
